import { fetchQuery, graphql, type Environment } from 'react-relay';

import { logger } from '@townsquare/logging/logger';

import { type rbacCheckQuery as rbacCheckQueryType } from './__generated__/rbacCheckQuery.graphql';

export const getRbacCheck = async (workspaceUuid: string, app: 'projects' | 'goals', environment: Environment) => {
	try {
		const data = await fetchQuery<rbacCheckQueryType>(
			environment,
			graphql`
				query rbacCheckQuery($workspaceUuid: UUID!, $isForGoals: Boolean!, $isForProjects: Boolean!) {
					workspaceByUuid(uuid: $workspaceUuid) {
						aiPermittedForGoals @include(if: $isForGoals)
						aiPermittedForProjects @include(if: $isForProjects)
					}
				}
			`,
			{
				workspaceUuid,
				isForGoals: app === 'goals',
				isForProjects: app === 'projects',
			},
			{
				fetchPolicy: 'store-or-network',
			},
		).toPromise();

		if (!data) {
			return false;
		}

		if (app === 'goals') {
			return !!data.workspaceByUuid?.aiPermittedForGoals;
		} else if (app === 'projects') {
			return !!data.workspaceByUuid?.aiPermittedForProjects;
		}

		return false;
	} catch (error) {
		logger.error('Failed to load RBAC check', {
			extra: {
				workspaceUuid,
				app,
				error,
			},
		});

		return false;
	}
};
